module.exports = __webpack_public_path__ + "0bfd26d32eb00d0546368c4b74e44545.jpg";